<mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
  <mat-card-content fxLayoutAlign="center center" fxLayout="column">
    <div fxFlex="100" class="filter w-100" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
      <mat-form-field class="accent">
        <mat-label>Search tags by name</mat-label>
        <input matInput type="text"
          [(ngModel)]="searchTerm"
          (keyup.enter)="filterData()"
          (keyup.esc)="searchTerm=''; filterData()"
          name="searchTerm"
          placeholder="Search Name">
        <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; filterData()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <div fxLayout="row" fxLayoutGap="10px">
        <button
          type="submit"
          mat-flat-button color="primary"
          (click)="filterData()"
          matTooltip="Search"
          [class.button-spinner]="loading"
          [disabled]="loading">
          <mat-icon>search</mat-icon> Search
        </button>
        <button
            [matTooltip]="(data.data?.length > 0 ? 'Add Tag' : 'Add Tag to get started!')"
            mat-flat-button color="accent" (click)="addTag()">
            <mat-icon>add</mat-icon> Add Tag
        </button>
      </div>
    </div>
    <div class="m-b-20 w-100" fxFlex="100">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <small class="text-info"><i>filter:</i></small>
        <small *ngIf="!resourceTypeFilter" class="text-warning">
          no filters currently applied 
        </small>
        <mat-chip-list>
          <mat-chip *ngIf="resourceTypeFilter !== undefined" (click)="setTypeFilter(undefined)">
            <span>{{ tagTypes[resourceTypeFilter] }}</span>
            <button matChipRemove (click)="setTypeFilter(undefined)">
              <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip>
          <ng-container *ngIf="resourceTypeFilter === undefined">
            <mat-chip *ngFor="let tagType of tagTypes | enumKeyValue:'asc'" color="accent">
              <span>{{ tagTypes[tagType.value] }}</span>
              <button matChipRemove (click)="setTypeFilter(tagType.value)">
                <mat-icon color="accent" matTooltip="Filter">filter_alt</mat-icon>
              </button>
            </mat-chip>
          </ng-container>
        </mat-chip-list>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card class="contrast" *ngFor="let item of filteredData" [ngClass.lt-sm]="{'mat-card-inline-sm': true}" [class.banner-warning]="isExpired(item.releaseDate)">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="30" fxLayoutAlign="center start" fxLayout="column" fxLayoutGap="2px">
      <strong [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="item?.name | encodeHtml | highlight: searchTerm"></strong>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
        <small>{{ tagTypes[item.resourceType] }}</small>
      </div>
    </div>
    <div fxFlex="70" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="10px">
      <!-- <div *ngIf="item?.total !== null && item?.totalLive !== null" fxLayoutAlign="center center" fxLayout="column" fxLayoutGap="2px">
        <small>Total Live</small>
        <small matTooltip="Total Live / Total Release Items">{{ item?.totalLive }} / <span [class.text-warning]="item.totalLive < item.total" [class.text-success]="item.totalLive === item.total">{{ item?.total }}</span></small>
      </div>
      <div *ngIf="item?.totalRendered !== null" fxLayoutAlign="center center" fxLayout="column" fxLayoutGap="2px">
        <small>Total Rendered</small>
        <small matTooltip="Total Renders During the Release"><span class="text-info">{{ item?.totalRendered }}</span></small>
      </div>
      <div fxLayoutAlign="end center" fxLayout="row">
        <button mat-icon-button color="accent" aria-label="Edit Release" matTooltip="Edit Release" (click)="onClickRelease(item)">
          <mat-icon>edit</mat-icon>
        </button>
      </div> -->
    </div>
  </mat-card-content>
</mat-card>